import type { PageCard } from '@/play/pageTypes'
import { OozeCardArt } from './CardArt'

/** What the home screen shows for this page; the page itself is ./index.ts, loaded when it opens. */
export const card: PageCard = {
  id: 'ooze',
  number: 17,
  title: 'Ooze',
  question: 'Does opening a container and watching its contents ooze out and collect below feel good?',
  status: 'open',
  accent: '#ff9fc6',
  CardArt: OozeCardArt,
}
